import React from 'react'
import { useWillPipe } from '@morningtrain/react-helpers'
import { Env } from '@morningtrain/helpers'
import { toJS } from 'mobx'

export default function SetItemsInEnvOnPipe () {
  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      const items = {}
      const byItem = {}

      if (payload.data && payload.data.collection) {
        const categories = toJS(payload.data.collection)
        if (categories.length > 0) {
          categories.forEach(category => {
            const collection = category.get('collection')
            if (collection && collection.length > 0) {
              collection.forEach(item => {
                items[item.id] = item

                if (item.norms_by_weekday) {
                  const normsByWeekday = Object.values(item.norms_by_weekday)

                  normsByWeekday.forEach(normByWeekday => {
                    if (!normByWeekday.norm_offset) {
                      return
                    }

                    if (!byItem[normByWeekday.inventory_item_id]) {
                      byItem[normByWeekday.inventory_item_id] = {}
                    }
                    byItem[normByWeekday.inventory_item_id][normByWeekday.weekday] = normByWeekday
                  })
                }
              })
            }
          })
        }
      }

      Env.set('globals.inventory.norms.items', items)
      Env.set('globals.inventory.norms.by_item', byItem)

      resolve(payload)
    })
  }, [])

  return null
}
